import React from 'react';
import DraftOrderCardExpandable from './DraftOrderCardExpandable';
// import PageIntro from './other/PageIntro';

import Sorting from './other/Sorting';
import Pagination from './other/Pagination';

// function DraftOrdersList({ draftOrders, onOrderRemoved, showModal }) {
function DraftOrdersList({
  draftOrders,
  sortBy,
  sortDir,
  sortOptions,
  onSortChange,
  onOrderRemoved,
  showModal,
  hasNextPage,
  loadingMore,
  onLoadMore,
  filterBy,
  filterOptions,
  onFilterChange,
  showSorting,
}) {
  return (
    <div id="draft-orders">
      {/* <PageIntro heading="WillyGoat Quotes" message="Welcome to the WillyGoat Quote Center" /> */}

      {showSorting && (
        <Sorting
          draftOrders={draftOrders}
          onOrderRemoved={onOrderRemoved}
          showModal={showModal}
          sortBy={sortBy}
          sortDir={sortDir}
          sortOptions={sortOptions}
          onSortChange={onSortChange}
          filterBy={filterBy}
          filterOptions={filterOptions}
          onFilterChange={onFilterChange}
        />
      )}

      <div id="orders-container">
        {draftOrders.map((draftOrder, index) => (
          <DraftOrderCardExpandable
            key={draftOrder.id}
            draftOrder={draftOrder}
            index={index}
            onOrderRemoved={onOrderRemoved}
            showModal={showModal}
            filterBy={filterBy}
          />
        ))}
      </div>

      <Pagination hasNextPage={hasNextPage} loadingMore={loadingMore} onLoadMore={onLoadMore} />


    </div>
  );
}

export default DraftOrdersList;
